export default __webpack_public_path__ + "static/social media 5-4f6c31c047b0c7b524d376b6d30eca44.webp";